<template>
  <div class="wlx-site-manager-wrapper">
    <div class="yk-wrap-fixed clearfix">
      <header class="ad-school-manager-head fr">
        <el-form :inline="true" size="small">
          <div class="d-search-form-news">
            <el-form-item>
              <el-input v-model="provinceName" placeholder="请输入单位名称" clearable></el-input>
            </el-form-item>
             <el-form-item>
              <el-select v-model="comType" clearable placeholder="请选择单位类型">
                <el-option
                  v-for="item in comTypeList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.lable"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="download()">导出Excel</el-button>
            </el-form-item>
          </div>
        </el-form>
      </header>
      <div style="padding-left:30px;">
        <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="companyName" label="单位名称"></el-table-column>
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">院校</span>
              <span v-if="scope.row.type == 2">企业</span>
            </template>
          </el-table-column>
          <el-table-column prop="contacts" label="联系人姓名"></el-table-column>
          <el-table-column prop="contactsPhone" label="联系人电话"></el-table-column>
          <el-table-column prop="job" label="联系人职务"></el-table-column>
          <el-table-column prop="email" label="联系人邮箱"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="edit(scope.row)" type="primary">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="news-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>

    <!-- 毕业生就业情况统计表（企业） -->
    <div class="basic-form-main" id="table" v-show="show">
      <div v-for="(li,index) in list" :key="index" v-if="li.type == 2">
        <table border="0" cellspacing="0" cellpadding="0" class="school-static-table">
          <tr>
            <td colspan="8">
              <div class="table-head-con">毕业生就业情况统计表（企业）</div>
            </td>
          </tr>
          <tr>
            <td class="td-label">单位名称</td>
            <td colspan="3">
              <span>{{li.companyName}}</span>
            </td>
            <td colspan="2" class="td-label">疫情期间拟招工时间</td>
            <td colspan="2">
              <span>{{li.recruitmentTime}}</span>
            </td>
          </tr>
          <tr>
            <td class="td-label">联系人</td>
            <td>
              <span>{{li.contacts}}</span>
            </td>
            <td class="td-label">电话</td>
            <td>
              <span>{{li.contactsPhone}}""</span>
            </td>
            <td class="td-label">职务</td>
            <td>
              <span>{{li.job}}</span>
            </td>
            <td class="td-label">邮箱</td>
            <td>
              <span>{{li.email}}</span>
            </td>
          </tr>
        </table>
        <table
          v-for="(item,index) in li.enterpriseJson"
          :key="index"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="school-static-table"
          :class="{'lastTable' : index == li.enterpriseJson.length - 1}"
        >
          <tr>
            <td class="td-label">岗位名额</td>
            <td>
              <span>{{item.NumberOfPosts}}</span>
            </td>
            <td class="td-label">用工需求</td>
            <td>
              <span>{{item.LaborDemand}}</span>
            </td>
            <td class="td-label">工作内容</td>
            <td>
              <span>{{item.JobContent}}</span>
            </td>
            <td class="td-label">面向毕业生层次</td>
            <td>
              <span>{{item.ForGraduatesArrangement}}</span>
            </td>
          </tr>
          <tr>
            <td class="td-label">工作地区</td>
            <td>
              <span>{{item.WorkingArea}}</span>
            </td>
            <td class="td-label">年薪酬</td>
            <td>
              <span>{{item.YearlySalary}}</span>
            </td>
            <td class="td-label">保险情况</td>
            <td colspan="3">
              <span>{{item.IsInsure}}</span>
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td colspan="8"></td>
          </tr>
          <tr>
            <td colspan="8"></td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 毕业生就业情况统计表（院校） -->
    <div class="basic-form-main" id="table1" v-show="show">
      <div v-for="(li,index) in list" :key="index" v-if="li.type == 1">
        <table border="0" cellspacing="0" cellpadding="0" class="school-static-table">
          <tr>
            <td colspan="8">
              <div class="table-head-con">毕业生就业情况统计表（院校）</div>
            </td>
          </tr>
          <tr>
            <td class="td-label">单位名称</td>
            <td>
              <span>{{li.companyName}}</span>
            </td>
            <td class="td-label">学校类别</td>
            <td>
              <span>{{li.schoolType}}</span>
            </td>
            <td class="td-label">地址</td>
            <td colspan="3">
              <span>{{li.schoolAddress}}</span>
            </td>
          </tr>
          <tr>
            <td class="td-label">联系人</td>
            <td>
              <span>{{li.contacts}}</span>
            </td>
            <td class="td-label">电话</td>
            <td>
              <span>{{li.contactsPhone}}""</span>
            </td>
            <td class="td-label">职务</td>
            <td>
              <span>{{li.job}}</span>
            </td>
            <td class="td-label">邮箱</td>
            <td>
              <span>{{li.email}}</span>
            </td>
          </tr>
          <tr v-for="(item,index) in li.schoolJson" :key="index">
            <td class="td-label">专业</td>
            <td colspan="3">
              <span>{{item.Major}}</span>
            </td>
            <td class="td-label">毕业生人数</td>
            <td colspan="3">
              <span>{{item.GraduateCount}}</span>
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td colspan="8"></td>
          </tr>
          <tr>
            <td colspan="8"></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      id: "",
      provinceName: "",
      Contacts: "",
      ContactsPhone: "",
      show: false,
      comType:"",
      /* --------------------------------------- */
      schoolOption: [
        {
          value: "中职",
          label: "中职"
        },
        {
          value: "高职",
          label: "高职"
        },
        {
          value: "本科",
          label: "本科"
        }
      ],
      zzMajor: [
        {
          value: "物流服务与管理",
          label: "物流服务与管理"
        },
        {
          value: "国际货运代理专业",
          label: "国际货运代理专业"
        },
        {
          value: "冷链物流服务与管理专业",
          label: "冷链物流服务与管理专业"
        }
      ],
      gzMajor: [
        {
          value: "物流工程技术",
          label: "物流工程技术"
        },
        {
          value: "物流信息技术",
          label: "物流信息技术"
        },
        {
          value: "物流管理",
          label: "物流管理"
        },
        {
          value: "物流金融管理",
          label: "物流金融管理"
        },
        {
          value: "工程物流管理",
          label: "工程物流管理"
        },
        {
          value: "冷链物流技术与管理",
          label: "冷链物流技术与管理"
        },
        {
          value: "采购与供应管理",
          label: "采购与供应管理"
        },
        {
          value: "铁路物流管理",
          label: "铁路物流管理"
        },
        {
          value: "港口物流管理",
          label: "港口物流管理"
        },
        {
          value: "航空物流",
          label: "航空物流"
        },
        {
          value: "报关与国际货运",
          label: "报关与国际货运"
        }
      ],
      bkMajor: [
        {
          value: "物流管理",
          label: "物流管理"
        },
        {
          value: "物流工程",
          label: "物流工程"
        },
        {
          value: "采购管理",
          label: "采购管理"
        },
        {
          value: "供应链管理",
          label: "供应链管理"
        }
      ],
      comTypeList:[
        {
          lable: 1,
          value: "院校"
        },
        {
          lable: 2,
          value: "企业"
        },

      ]

    };
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getProvincialHeadList(1);
  },
  methods: {
    getProvincialHeadList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/Statistics/getStatisticsList", {
          stype: this.comType,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getProvincialHeadList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getProvincialHeadList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.id);
      });
    },
    setProvincialHead() {
      var that = this;
      this.$http
        .post("/api/XOrg/ProvincialHead/setProvincialHead", {
          id: that.id,
          contacts: that.Contacts,
          contactsPhone: that.ContactsPhone
        })
        .then(rst => {
          if (rst.code === 1) {
            that.$message.success(rst.msg);
            that.getProvincialHeadList();
            that.addNewNoticeVisible = false;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    edit(row) {
      // this.addNewNoticeVisible = true;
      // this.id = row.Id;
      // this.Contacts = row.Contacts;
      // this.ContactsPhone = row.ContactsPhone;
      if (row.type == 1) {
        this.$router.push({
          name: "schoolStaticEdit",
          params: {
            sid: row.id
          }
        });
      } else {
        this.$router.push({
          name: "enterpriseStaticEdit",
          params: {
            eid: row.id
          }
        });
      }
    },
    cancel() {
      this.addNewNoticeVisible = false;
    },
    search() {
      this.getProvincialHeadList(1);
    },
    download() {
      this.downloadExl("table", "毕业生就业情况统计表（企业）");
      this.downloadExl("table1", "毕业生就业情况统计表（院校）");
    },
    downloadExl(tableId, title) {
      let wb = XLSX.utils.table_to_book(document.getElementById(tableId)),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        },
        wbout = XLSX.write(wb, wopts);

      FileSaver.saveAs(
        new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream;charset=utf-8"
        }),
        title + ".xlsx"
      );
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefind") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    }
  }
};
</script>


<style lang='scss'>
.wlx-site-manager-wrapper {
  .news-page-con {
    padding: 20px 0;
    text-align: center;
  }
  .d-search-form-news {
    margin: 13px 0px 0 0;
  }
  .ad-school-manager-head {
    // position: fixed;
    // top: 132px;
    // right: 0;
    // height: 0px;
    // width: calc(100% - 240px);
    // z-index: 1000;
    // text-align: right;
  }
}
</style>
